import { useEffect, useRef } from "react";
import axios, { AxiosError } from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { axiosClient } from "@/lib/axiosClient";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next"; // 1. Import i18n hook

export default function AccountActivationProcess() {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace registration
    const { token } = useParams();
    const navigate = useNavigate();
    const hasActivated = useRef(false); // ✅ flag agar tidak aktif dua kali

    useEffect(() => {
        const activateAccount = async () => {
            if (hasActivated.current) return; // ✅ hindari pemanggilan ulang
            hasActivated.current = true;

            try {
                const res = await axiosClient.get(`/activate/${token}`);
                const status = res.data.status;

                if (status === "activated") {
                    navigate("/activation/success");
                } else if (status === "already_activated") {
                    navigate("/activation/already");
                } else {
                    navigate("/activation/failed");
                }
            } catch (error) {
                if (axios.isAxiosError(error)) {
                    const err = error as AxiosError<{ message?: string }>;
                    console.error("Aktivasi gagal:", err.response?.data?.message);
                } else {
                    console.error("Kesalahan tidak terduga:", error);
                }
                navigate("/activation/failed");
            }
        };

        if (token) activateAccount();
    }, [token, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-100">
            <div className="bg-white shadow-md rounded-2xl p-10 text-center">
                <Loader2 className="w-10 h-10 text-indigo-600 animate-spin mx-auto mb-4" />
                <h1 className="text-lg font-semibold text-gray-700">
                    {t('activation_process.title')}
                </h1>
                <p className="text-sm text-gray-500 mt-2">
                    {t('activation_process.subtitle')}
                </p>
            </div>
        </div>
    );
}